import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: [
    './expansion-panel.component.scss',
    './expansion-panel.component.en.scss',
  ],
})
export class ExpansionPanelComponent implements OnInit, AfterViewInit {
  @Input() title?: string;
  @Input() isExpanded: boolean = false;
  @Input() filters?: any[];
  @Input() selectedFilters!: string | undefined;
  @Input() selectedDepartmentsFilters!: string | undefined;
  @Input() selectedFacultiesFilters!: string | undefined;
  @Input() isKeyString!: boolean | false;
  @Input() isUsePersonalizationFilters!: boolean | false;
  @Input() disabled: boolean = false;

  @ViewChildren(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;

  @Output() filterStatusChanged = new EventEmitter<{
    event: MatCheckboxChange;
    filter: any;
  }>();

  constructor() {}

  ngAfterViewInit(): void {
    if (this.isKeyString) {
      this.pushFiltersTypeString();
    } 
    else if (this.isUsePersonalizationFilters) {
      this.pushFiltersTypeByPersonalizationFilters();
    }
    else this.pushFilters();
  }

  pushFilters() {
    if (this.selectedFilters) {
      let filterKeys = this.selectedFilters.split(',').map(Number);
      this.checkFilterByKeys(filterKeys);
    }
  }
  pushFiltersTypeString() {
    if (this.selectedFilters) {
      let filterKeys = this.selectedFilters.split(',').map(String);
      this.checkFilterByKeysTypeString(filterKeys);
    }
  }
  pushFiltersTypeByPersonalizationFilters() {
    if (this.selectedFilters) {
      let filterKeys = this.selectedFilters.split(',').map(Number);
      let filters = this.filters?.filter(c => filterKeys.includes(c.filterKey) && !c.isDepartmentsFilter && !c.isFacultiesFilter);
      filters?.forEach((filter) => {
        this.pushCheckFilterWithPersonalizationFilters(filter);
      });
    }

    if (this.selectedDepartmentsFilters) {
      let filterKeys = this.selectedDepartmentsFilters.split(',').map(Number);
      let filters = this.filters?.filter(c => filterKeys.includes(c.filterKey) && c.isDepartmentsFilter);
      filters?.forEach((filter) => {
        this.pushCheckFilterWithPersonalizationFilters(filter);
      });
    }

    if (this.selectedFacultiesFilters) {
      let filterKeys = this.selectedFacultiesFilters.split(',').map(Number);
      let filters = this.filters?.filter(c => filterKeys.includes(c.filterKey) && c.isFacultiesFilter);
      filters?.forEach((filter) => {
        this.pushCheckFilterWithPersonalizationFilters(filter);
      });
    }
  }

  ngOnInit(): void {}

  onCheckboxChanged(event: MatCheckboxChange, filter: any) {
    this.filterStatusChanged.emit({ event, filter });
  }

  checkMatchedFilter(key: string) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      if (checkbox.value == key) {
        checkbox.checked = true;
        this.isExpanded = true;
        const event = { checked: true } as MatCheckboxChange;
        const filter = this.filters?.find((f) => f.filterKey == parseInt(key));
        this.filterStatusChanged.emit({ event, filter });
      }
    });
  }
  checkMatchedFilterTypeString(key: string) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      if (checkbox.value == key) {
        checkbox.checked = true;
        this.isExpanded = true;
        const event = { checked: true } as MatCheckboxChange;
        const filter = this.filters?.find((f) => f.filterKey == key);
        this.filterStatusChanged.emit({ event, filter });
      }
    });
  }
  checkFilterByKeys(keys: number[]) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      let checkBoxValue = parseInt(checkbox.value);
      if (keys.includes(checkBoxValue)) {
        let index = keys.indexOf(checkBoxValue);
        keys.splice(index, 1);
        this.isExpanded = true;
        checkbox.checked = true;
      }
    });
  }
  checkFilterByKeysTypeString(keys: string[]) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      let checkBoxValue = checkbox.value;
      if (keys.includes(checkBoxValue)) {
        let index = keys.indexOf(checkBoxValue);
        keys.splice(index, 1);
        this.isExpanded = true;
        checkbox.checked = true;
      }
    });
  }
  checkMatchedFilterWithPersonalizationFilters(key: any) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      if (checkbox.value == key.value) {
        let filter = this.filters?.find(
          (f) =>
            f.filterKey == parseInt(key.value) &&
            f.isDepartmentsFilter == key.isDepartmentsFilter &&
            f.isFacultiesFilter == key.isFacultiesFilter
        );

        if (filter) {
          checkbox.checked = true;
          this.isExpanded = true;
          let event = { checked: true } as MatCheckboxChange;
          this.filterStatusChanged.emit({ event, filter });
        }
      }
    });
  }
  pushCheckFilterWithPersonalizationFilters(key: any) {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      if (checkbox.value == key.filterKey) {
        let filter = this.filters?.find(
          (f) =>
            f.filterKey == parseInt(key.filterKey) &&
            f.isDepartmentsFilter == key.isDepartmentsFilter &&
            f.isFacultiesFilter == key.isFacultiesFilter
        );

        if (filter) {
          checkbox.checked = true;
          this.isExpanded = true;
        }
      }
    });
  }
  clearFilter() {
    this.checkboxes.forEach((checkbox: MatCheckbox) => {
      checkbox.checked = false;
    });
  }
}
